import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { makeStyles } from '@mui/styles';
import {
	IconButton,
	Tooltip,
	TextField
} from '@mui/material';

import SaveIcon from '@mui/icons-material/Save';
import DeleteIcon from '@mui/icons-material/Delete';
import { DataTable } from 'components';

const useStyles = makeStyles((theme) => ({
	root: {},
	content: {
		padding: 0,
	},
	inner: {
		minWidth: 700,
	},
	nameCell: {
		display: 'flex',
		alignItems: 'center',
	},
	avatar: {
		height: 42,
		width: 42,
		marginRight: theme.spacing(1),
	},
	actions: {
		padding: theme.spacing(1),
		justifyContent: 'flex-end',
	},
	primaryButton: {
		color: theme.palette.primary.main
	},
	errorButton: {
		color: theme.palette.error.main
	}
}));

const DataTable4G = (props) => {
	const { className, data, editValue, updateSelectedRows, ...rest } = props;
	const classes = useStyles();

	const _editValue = (id, rowData) => {
		const row = _.findWhere(data, { id });
		const newRow = { ...row, tac: rowData[6], pci: rowData[7], pss: rowData[8], sss: rowData[9], rsi: rowData[10] };
		editValue(newRow, '4g');
	};

	const _renderActions = (tableMeta) => {
		const { rowData } = tableMeta;
		return (
			<>
				<Tooltip title="Edit">
					<IconButton edge="end" size="small" onClick={() => _editValue(rowData[0], rowData)} className={classes.primaryButton}>
						<SaveIcon />
					</IconButton>
				</Tooltip>
				<Tooltip title="Delete">
					<IconButton edge="end" size="small" className={classes.errorButton}>
						<DeleteIcon />
					</IconButton>
				</Tooltip>
			</>
		);
	};

	const _getTableColumns = () => (
		[
			{
				name: 'id',
				label: 'Id',
				options: {
					display: false,
					filter: false,
					viewColumns: false,
					filterType: 'textField',
				}
			},
			{
				name: 'name',
				label: 'Name',
				options: {
					display: true,
					filterType: 'textField',
				}
			},
			{
				name: 'cellId',
				label: 'CellId',
				options: {
					display: true,
					filterType: 'textField',
				}
			},
			{
				name: 'operatorName',
				label: 'Operator',
				options: {
					display: true,
					filterType: 'textField',
				}
			},
			{
				name: 'nodeName',
				label: 'Node Name',
				options: {
					display: true,
					filterType: 'textField',
				}
			},
			{
				name: 'tac',
				label: 'TAC',
				options: {
					display: true,
					filterType: 'textField',
					empty: true,
					customBodyRender: (value, tableMeta, updateValue) => (
						<TextField
							fullWidth
							name="TAC"
							value={value}
							variant="outlined"
							onChange={(event) => {
								updateValue(event.target.value);
							}}
						/>
					)
				}
			},
			{
				name: 'pci',
				label: 'PCI',
				options: {
					display: true,
					filterType: 'textField',
					empty: true,
					customBodyRender: (value, tableMeta, updateValue) => (
						<TextField
							fullWidth
							name="PCI"
							value={value}
							variant="outlined"
							onChange={(event) => {
								updateValue(event.target.value);
							}}
						/>
					)
				}
			},
			{
				name: 'pss',
				label: 'PSS',
				options: {
					display: true,
					filterType: 'textField',
					empty: true,
					customBodyRender: (value, tableMeta, updateValue) => (
						<TextField
							fullWidth
							name="PSS"
							value={value}
							variant="outlined"
							onChange={(event) => {
								updateValue(event.target.value);
							}}
						/>
					)
				}
			},
			{
				name: 'sss',
				label: 'SSS',
				options: {
					display: true,
					filterType: 'textField',
					empty: true,
					customBodyRender: (value, tableMeta, updateValue) => (
						<TextField
							fullWidth
							name="SSS"
							value={value}
							variant="outlined"
							onChange={(event) => {
								updateValue(event.target.value);
							}}
						/>
					)
				}
			},
			{
				name: 'rsi',
				label: 'RSI',
				options: {
					display: true,
					filterType: 'textField',
					empty: true,
					customBodyRender: (value, tableMeta, updateValue) => (
						<TextField
							fullWidth
							name="RSI"
							value={value}
							variant="outlined"
							onChange={(event) => {
								updateValue(event.target.value);
							}}
						/>
					)
				}
			},
			{
				name: 'edited',
				label: 'Edited',
				options: {
					display: true,
					filterType: 'textField',
				}
			},
			{
				name: 'action',
				label: 'Actions',
				options: {
					filter: false,
					sort: false,
					viewColumns: false,
					empty: true,
					customBodyRender: (value, tableMeta, updateValue) => _renderActions(tableMeta)
				}
			},
		]
	);

	const _getTableOptions = () => ({
		filterType: 'dropdown',
		selectableRows: 'multiple',
		expandableRows: false, // Try Adding This
		filter: false,
		search: false,
		responsive: 'scrollFullHeight',
		pagination: false,
		selectableRowsHeader: true,
		selectToolbarPlacement: 'none'
	});

	return (
		<div {...rest} className={clsx(classes.root, className)}>
			<DataTable
				id="dataTable4G"
				title="Cells 4G"
				data={data}
				// data={plan ? dummyData.plan : dummyData.noplan}
				columns={_getTableColumns()}
				rowsPerPage={10}
				// tableBodyMaxHeight="30em"
				options={_getTableOptions()}
				onRowSelection={(selectedRows) => {
					updateSelectedRows(selectedRows, '4g');
				}}
			/>
		</div>
	);
};

DataTable4G.propTypes = {
	className: PropTypes.string,
	data: PropTypes.array.isRequired,
	editValue: PropTypes.func,
	updateSelectedRows: PropTypes.func
};

export default DataTable4G;
